import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Credentials from "@/pages/Credentials";
import Categories from "@/pages/Categories";
import Groups from "@/pages/Groups";
import Users from "@/pages/Users";
import Audit from "@/pages/Audit";
import Profile from "@/pages/Profile";

function Protected({ children, adminOnly = false }) {
  const { user } = useAuth();
  const location = useLocation();
  if (user === undefined) {
    return <div className="min-h-screen flex items-center justify-center text-gray-500">Carregando...</div>;
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/dashboard" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
          <Route path="/credenciais" element={<Protected><Credentials /></Protected>} />
          <Route path="/cofres" element={<Protected><Groups /></Protected>} />
          <Route path="/categorias" element={<Protected><Categories /></Protected>} />
          <Route path="/usuarios" element={<Protected adminOnly><Users /></Protected>} />
          <Route path="/auditoria" element={<Protected adminOnly><Audit /></Protected>} />
          <Route path="/perfil" element={<Protected><Profile /></Protected>} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
